<template>
  <div class="fee-confirm-component">
    <CollapsePanel style="padding: 0" v-model="showChart">
      <div slot="title">
        <span class="rectangle" style=" background: #f09537"></span>
        费用确认进展(未确认:
        <span
          style="color: red; cursor: pointer"
          @click="handleFeeConfirmationRoute"
          >{{ chargeUnconfirmedNum }}</span>箱)
      </div>
      <span slot="port">
          <div class="port-checkbox portCheckbox"  v-if="showChart">
            <CheckboxGroup v-model="boundTypeIds">
              <Checkbox
                  v-for="item in boundTypeList"
                  :key="item.id"
                  :label="item.id"
                  >{{ item.name }}</Checkbox
                >
            </CheckboxGroup>
          </div>
        </span>
      <span slot="time">
        <div class="dateRange-select" v-show="showChart">
          <span>时间</span>
          <Select
            v-model="dateRange"
            style="width: 100px; margin-left: 10px"
            size="small"
          >
            <Option
              v-for="item in dateRangeList"
              :value="item.value"
              :key="item.value"
              >{{ item.label }}</Option
            >
          </Select>
        </div>
      </span>
      <div>
        <div class="chart-head">
          <div class="legend">
            <div class="legend-item">
              <span
                class="color-area"
                :style="{ backgroundColor: chartColorTheme[0] }"
              ></span>
              <span class="legend-title">鸭嘴兽录账中</span>
            </div>
            <div class="legend-item">
              <span
                class="color-area"
                :style="{ backgroundColor: chartColorTheme[2] }"
              ></span>
              <span data-v-82e36644="" class="legend-title">未确认</span>
            </div>
            <div class="legend-item">
              <span
                class="color-area"
                :style="{ backgroundColor: chartColorTheme[1] }"
              ></span>
              <span data-v-82e36644="" class="legend-title">已确认</span>
            </div>
          </div>
        </div>
        <div>
          <div @click="() => {}">
            <div id="fee-confirm-chart" ref="chartEle"></div>
            <span></span>
          </div>
        </div>
        <Spin size="large" fix v-if="loading"></Spin>
      </div>
    </CollapsePanel>
  </div>
</template>

<script>
import CollapsePanel from "@/components/place-order/collapse-panel";
import echarts from "@moon-land/echarts/lib/echarts";
import "@moon-land/echarts/lib/chart/bar";
import "@moon-land/echarts/lib/component/grid";
import "@moon-land/echarts/lib/component/dataZoom";
import "@moon-land/echarts/lib/component/markLine";
import "@moon-land/echarts/lib/component/tooltip";
import "@moon-land/echarts/lib/component/legend";
import dayjs from "dayjs";
import _ from "lodash";

import { fetchFeeConfirmationHistory } from "@/api/feeConfirmation";

let chartInstance = null;

window.onresize = () => {
  chartInstance && chartInstance.resize();
};

const maxWith = window.innerWidth;
function chartDisplayPercent(dateRange) {
  let ratio = 1;
  if (dateRange === 2) {
    ratio = 0.9;
  } else if (dateRange === 3) {
    ratio = 1;
    return 100;
  }

  let result = 100;
  if (maxWith >= 1500) {
    result = 100;
  } else if (maxWith >= 1200) {
    result = 80;
  } else if (maxWith >= 1000) {
    result = 65;
  }

  return result * ratio;
}

const COLOR_THEME = ["#cdcdcd", "#27b148", "#f00"];
const WEEK_DAY = {
  1: "周一",
  2: "周二",
  3: "周三",
  4: "周四",
  5: "周五",
  6: "周六",
  7: "周日",
};

export default {
  components: {
    CollapsePanel,
  },
  mounted() {
    this.renderChart();
  },
  data() {
    return {
      boundTypeList:[{
        id: 'IB',
        name: '进口'
      },{
        id: 'OB',
        name: '出口'
      }],
      boundTypeIds:['IB','OB'],
      loading: false,
      chartColorTheme: COLOR_THEME,
      showChart: true,
      COLOR_THEME: COLOR_THEME,
      dateRange: 1,
      dateRangeList: [
        {
          value: 1,
          label: "最近一个月",
        },
        {
          value: 2,
          label: "最近二个月",
        },
        {
          value: 3,
          label: "最近三个月",
        },
      ],
      chargeUnconfirmedNum: 0,
    };
  },
  methods: {
    async renderChart(payload = {}) {
      const chartEle = this.$refs.chartEle;
      if (chartEle){
        chartInstance = echarts.init(chartEle);
      }
      this.loading = true;
      const dateRange = this.dateRange;
      const [startDate, endDate] = this.genMonthRange(dateRange);
      const resp = await fetchFeeConfirmationHistory({
        ...{boundTypeIds:this.boundTypeIds},
        startDate,
        endDate,
      });
      // console.log('fee===>',resp)
      const { chargeUnconfirmedNum, dayChargeConfirmStatisticsDto = [] } = resp;
      this.chargeUnconfirmedNum = chargeUnconfirmedNum;
      this.showChart = false
      dayChargeConfirmStatisticsDto.forEach(v => {
        if (v.chargeConfirmedNum || v.chargeUnconfirmedNum || v.matchChargeNum){
          this.showChart = true
        }
      });
      const data = dayChargeConfirmStatisticsDto.map((v) => ({
        ...v,
        date: v.planArrivalDate,
        chargeConfirmedNum: v.chargeConfirmedNum ? v.chargeConfirmedNum : null,
        matchChargeNum: v.matchChargeNum ? v.matchChargeNum : null,
        chargeUnconfirmedNum: v.chargeUnconfirmedNum
          ? v.chargeUnconfirmedNum
          : null,
      }));
      const dataMap = _.keyBy(data, "date");
      // console.log('===>dataMap',dataMap)
      this.loading = false;
      chartInstance.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          formatter: (data) => {
            return [
              data[0].name,
              ...data.map((v) => `${v.seriesName}: ${v.data || 0}`),
            ].join("<br/>");
          },
        },
        grid: {
          left: "40px",
          right: "100px",
          bottom: "80px",
          top: "20px",
        },
        legend: {
          data: ["鸭嘴兽录账中", "已确认", "未确认"],
          bottom: 0,
          selectedMode: false,
          show: false,
        },
        xAxis: {
          type: "category",
          // maxInterval: 1,
          // minInterval: 1,
          axisLabel: {
            interval: () => {
              if (dateRange === 1) {
                return 1;
              } else if (dateRange === 2) {
                return 6;
              } else {
                return "auto";
              }
            },
            formatter: (value, index) => {
              const date = dayjs(value).format("MM/DD");
              const dayOfWeek = dataMap[value].dayOfWeek;
              const result = [date, `{a|${WEEK_DAY[dayOfWeek]}}`].join("\n");

              if (dateRange === 1) {
                return result;
              }
              if (dateRange === 2 && index % 3 === 0) {
                return result;
              }
              if (dateRange === 3 && [1].includes(dayOfWeek)) {
                return result;
              }
            },
            rich: {
              a: {
                padding: 4,
                fontSize: 10,
              },
            },
            fontSize: 10,
          },
          data: data.map((v) => v.date),
          axisTick: {
            show: false,
          },
        },
        yAxis: {
          type: "value",
          show: false,
          min: 0,
          max: (data) => data.max,
        },
        series: [
          {
            name: "鸭嘴兽录账中",
            data: data.map((v) => v.matchChargeNum),
            itemStyle: {
              color: COLOR_THEME[0],
            },
          },
          {
            name: "未确认",
            data: data.map((v) => v.chargeUnconfirmedNum),
            itemStyle: {
              color: COLOR_THEME[2],
            },
          },
          {
            name: "已确认",
            data: data.map((v) => v.chargeConfirmedNum),
            itemStyle: {
              color: COLOR_THEME[1],
            },
          },
        ]
          .reverse()
          .map((item) => ({
            ...item,
            barMinHeight: 20,
            type: "bar",
            stack: "总量",
            label: {
              show: dateRange !== 3,
              formatter: (v) => (dateRange === 3 ? "" : v.data),
            },
            barWidth: dateRange === 3 ? "50%" : "16px",
          })),
        dataZoom: [
          {
            show: true,
            zoomLock: false,
            start: 100 - chartDisplayPercent(dateRange),
            end: 100,
            bottom: 10,
            labelFormatter(index) {
              return dayjs(data[index].date).format("MM-DD");
            },
            textStyle: {
              fontSize: 10,
            },
          },
        ],
      });
      chartInstance.on("click", (data) => {
        this.handleFeeConfirmationRoute();
      });
      return;
    },
    handleFeeConfirmationRoute() {
      this.$router.push({
        name: "fee-confirmation_index",
      });
    },
    /**
     * @desc 生成月区间日期
     */
    genMonthRange(month = 1) {
      const now = dayjs();
      const prevDate = now.subtract(month, "month");
      return [prevDate.format("YYYY-MM-DD"), now.format("YYYY-MM-DD")];
    },
  },
  watch: {
    dateRange: {
      handler() {
        this.renderChart();
      },
    },
    boundTypeIds:{
      immediate: true,
      handler(val) {
        const payload = {
          boundTypeIds: this.boundTypeIds
        }
        this.renderChart({...payload})
      },
    }
  },
  beforeDestroy() {
    chartInstance = null;
  },
};
</script>

<style lang="less">
.fee-confirm-component {
  .chart-head {
    display: flex;
  }
  .dateRange-select {
    top: 0;
    right: 66px;
  }
  .legend {
    display: inline-block;
    vertical-align: middle;
    font-size: 14px;
    .legend-item {
      display: inline-flex;
      align-items: center;
      margin-left: 20px;
      &:first-of-type {
        margin-left: 0px;
      }
    }
    .color-area {
      display: inline-block;
      width: 30px;
      height: 14px;
      border-radius: 4px;
      margin-right: 6px;
    }
  }
  .portCheckbox {
  transform: translate(-50%, 0px);
  position: absolute;
  left: 50%;
  top: 0;
  font-size: 14px;
  width: 100%;
  text-align: center;
  .ivu-checkbox-wrapper {
    font-size: 14px;
  }
  .form-label {
    margin-right: 14px;
  }
}
  .ivu-checkbox-checked .ivu-checkbox-inner:after {
    top: 2px;
    left: 5px;
  }
}
.rectangle {
  display: inline-block;
  width: 10px;
  height: 10px;
  background: #4f97eb;
}
#fee-confirm-chart {
  height: 330px;
}

</style>



// WEBPACK FOOTER //
// fee-confirm-chart.vue?55c3781d